import type { Track } from '../../api.js';

export function moduleOf(track: Track): string {
  if (track.module) return track.module;
  const pipeIndex = track.title.indexOf('|');
  if (pipeIndex === -1) return 'general';
  const slug = track.title
    .slice(0, pipeIndex)
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9-]/g, '')
    .slice(0, 40);
  return slug || 'general';
}

export function distinctModules(tracks: Track[]): string[] {
  const seen = new Set<string>();
  for (const track of tracks) seen.add(moduleOf(track));
  return Array.from(seen).sort();
}
